exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkout[data-v-58546188]{position:relative}.apple-ic[data-v-58546188],.paypal-ic[data-v-58546188]{margin-top:-2px}.btn-modal-group[data-v-58546188]{display:flex;justify-content:space-between}.btn-modal-group .btn[data-v-58546188]{max-width:calc(50% - 5px)}.btn-modal-group .btn[data-v-58546188]:only-child{max-width:100%}.btn-gray[data-v-58546188]{height:54px}.btn-gray.btn-sm[data-v-58546188]{height:44px}.btn-gray .apple-ic[data-v-58546188],.btn-gray .paypal-ic[data-v-58546188]{opacity:.5}", ""]);

// exports
